/* GROUPS */
export const GET_COUNTIES = 'GET_COUNTIES';
export const GET_REGIONS = 'GET_REGIONS';
export const GET_CONSTITUENCIES = 'GET_CONSTITUENCIES';
export const GET_WARDS = 'GET_WARDS';


/* GROUPS */
export const GET_COUNTIES_SUCCESS = 'GET_COUNTIES_SUCCESS';
export const GET_REGIONS_SUCCESS = 'GET_REGIONS_SUCCESS';
export const GET_CONSTITUENCIES_SUCCESS = 'GET_CONSTITUENCIES_SUCCESS';
export const GET_WARDS_SUCCESS = 'GET_WARDS_SUCCESS';

/* GROUPS */
export const GET_COUNTIES_FAIL = 'GET_COUNTIES_FAIL';
export const GET_REGIONS_FAIL = 'GET_REGIONS_FAIL';
export const GET_CONSTITUENCIES_FAIL = 'GET_CONSTITUENCIES_FAIL';
export const GET_WARDS_FAIL = 'GET_WARDS_FAIL';